import React from 'react';
import { Link } from 'react-router-dom';
import getDateFromISOToLocal from '~/utils/getDateFromISOToLocal';
const DocumentActivityResult = ({ activity }) => {
    const documentLink = `/document/${activity.fileId}${window.location.search}`;
    const details = activity.metadata ? activity.metadata.fileName : '';
    return React.createElement("div", { className: 'recent-activity-result' },
        React.createElement("div", { className: 'date-col' }, getDateFromISOToLocal(activity.timestamp)),
        React.createElement("div", { className: 'activity-col' },
            React.createElement(Link, { to: documentLink }, activity.activityType)),
        React.createElement("div", { className: 'documents-col overflow-ellipsis' }, details));
};
export default DocumentActivityResult;
